module.exports = __webpack_public_path__ + "static/img/plice.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plice.png
// module id = 7gKu
// module chunks = 0